import React from 'react'
import ReactECharts from 'echarts-for-react'
import * as echarts from 'echarts'
import { useTranslation } from 'react-i18next'
import { useZtSubsetDataContext } from '../context'
import DataSkeleton from '../dataSkeleton'

echarts.registerTheme('theme_jekka', {
	backgroundColor: '#fff'
})

const ChartNine: React.FC = () => {
	const { t } = useTranslation()
	const { infoData, chartLoading } = useZtSubsetDataContext()

	const totalInvalidCount = infoData?.total?.invalid_count || 0
	// 在组件中提取 invalid 数据
	const invalidData = Object?.entries(infoData?.total || {})
		?.filter(([key]) => key.startsWith('invalid_') && key !== 'invalid_count')
		?.map(([key, value]) => {
			const num = Number(value) || 0
			return {
				type: key,
				value: num,
				rate: 0,
				name: t(`c_a_invalid_reason_${key}`)
			}
		})
		?.filter(item => item.value > 0)
		?.map(item => {
			const rate =
				totalInvalidCount > 0 ? `${((item.value / totalInvalidCount) * 100).toFixed(2)}%` : '0.00%'
			return {
				...item,
				rate
			}
		})

	const optionList = {
		tooltip: {
			trigger: 'item',
			confine: true,
			formatter: (params: any) => {
				const { name, value, data } = params
				return `
			<div style="font-weight:500;margin-bottom:6px;">${name}</div>
			<div>数量：<b>${value}</b></div>
			<div>占比：<b>${data.rate}</b></div>
		`
			}
		},
		legend: {
			bottom: -2,
			left: 'center',
			type: 'scroll',
			orient: 'horizontal',
			itemGap: 12,
			textStyle: {
				fontSize: 12
			}
		},

		grid: {
			left: 10,
			right: 10,
			bottom: 12,
			containLabel: true
		},

		series: [
			{
				type: 'pie',
				radius: ['42%', '72%'],
				center: ['50%', '44%'],
				padAngle: 1,
				avoidLabelOverlap: false,
				itemStyle: {
					borderRadius: 6,
					borderColor: '#fff',
					borderWidth: 1,
					shadowBlur: 10,
					shadowColor: 'rgba(0,0,0,0.2)'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{b}: {c} ({d}%)'
				},
				label: {
					show: true,
					position: 'outside', // 放到扇区外
					formatter: (params: any) => {
						const { name, data } = params
						return `${name}(${data.value}) ${data.rate}`
					},
					fontSize: 12,
					color: '#333',
					overflow: 'truncate', // 超长截断
					ellipsis: '…', // 显示省略号
					align: 'center'
				},
				emphasis: {
					label: {
						show: true,
						fontSize: 20,
						fontWeight: 'bold'
					}
				},
				labelLine: {
					show: true,
					length: 12,
					length2: 8,
					smooth: true
				},
				data: invalidData
			}
		]
	}

	return (
		<div className="bg-white rounded-lg overflow-hidden px-4 w-[49.5%] pb-[14px]">
			<div className="mt-[18px]">
				<div className="text-[14px] font-medium mb-[12px]">
					{t('c_a_outbound_call_invalid_connection')}
				</div>
				<div className="text-[14px] mb-[8px]">{t('c_a_outbound_call_invalid_connection_tips')}</div>
				<div className="text-[18px] font-medium flex items-center">
					<DataSkeleton value={Number(totalInvalidCount)} />
				</div>
			</div>

			<ReactECharts
				theme="theme_jekka"
				style={{ height: 330 }}
				option={optionList}
				showLoading={chartLoading}
			/>
		</div>
	)
}

export default ChartNine
